import { render, staticRenderFns } from "./FAlert.vue?vue&type=template&id=0240fda9&"
import script from "./FAlert.vue?vue&type=script&lang=js&"
export * from "./FAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports